import ProductionTaskPage from "@/pages/ProductionTaskPage";

export default function FrosterTask() {
  const localFixtureVariant =
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) &&
    new URLSearchParams(window.location.search).get("tt1046_fixture_variant") === "default";
  return <ProductionTaskPage role="froster" design={localFixtureVariant ? undefined : "delivery"} />;
}
